import { StoreBaseHandler } from "../../infrastructure/base-handlers";
import { ensureAreValidBasicActivityHistoryItems } from "../domain/validation/is-valid-basic-history-item";
import { updateActivityHistoryItem } from "./action";
import { UpdateHistoryItemPayload } from "./request";

export class UpdateHistoryItemHandler extends StoreBaseHandler {
  async handle(payload: UpdateHistoryItemPayload) {
    try {
      ensureAreValidBasicActivityHistoryItems([payload.item]);
      this.store.dispatch(
        updateActivityHistoryItem({
          id: payload.entityId,
          item: payload.item,
        }),
      );
    } catch (e) {
      console.error(e.message);
    }
  }
}
